// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "../css/" + "styles" + "." + "8d89f0bd4c2e1f7e6c0f" + ".css";
};